import {
  Mole as GraphqlMole,
  LockedMole as GraphqlLockedMole,
  Rarity as GraphqlRarity,
  FoodType as GraphqlFoodType,
} from 'vvs-gotchi-graphql'

export type Mole = {
  tokenId: number
  name?: string
  imageUrl?: string
  isEnlisted?: boolean
  rarity?: Rarity
  owner: string
  totalExp?: number
  isStaked?: boolean
  tier?: Tier
  boost?: string
  rank?: number
  hasFedToday: boolean
  health: number
  hasRankTier: boolean
  isLocked: boolean
  unlockAt?: string
}

export type LockedMole = {
  tokenId: number
  unlockAt?: string
}

export enum RankComparison {
  HIGHER,
  LOWER,
  EQUAL,
}

export enum Rarity {
  LEGENDARY,
  EPIC,
  RARE,
  SPECIAL,
  COMMON,
}
export enum Tier {
  JUNIOR,
  MASTER,
  GOD,
}

export enum FoodType {
  FRIES,
  BROCCOLI,
  GUACAMOLE,
}

export const moleFromGraphqlData = (data: GraphqlMole): Mole => {
  return {
    tokenId: data.tokenId,
    name: data.name ?? `#${data.tokenId}`,
    imageUrl: data.imageUrl,
    isEnlisted: data.isEnlisted,
    rarity: rarityFromGraphqlDataMap[data.rarity],
    owner: data.owner,
    totalExp: data.totalExp,
    isStaked: data.isStaked,
    tier: tierFromGraphqlDataMap[data.tier],
    boost: data.boost,
    rank: data.rank,
    hasFedToday: data.hasFedToday ?? false,
    health: data.health ?? 0,
    hasRankTier: data.tier && typeof data.rank === 'number',
    isLocked: data.isLocked,
    unlockAt: data.unlockAt,
  }
}

export const rarityFromGraphqlDataMap: Record<GraphqlRarity, Rarity> = {
  COMMON: Rarity.COMMON,
  SPECIAL: Rarity.SPECIAL,
  RARE: Rarity.RARE,
  EPIC: Rarity.EPIC,
  LEGENDARY: Rarity.LEGENDARY,
}
export const tierFromGraphqlDataMap: Record<number, Tier> = {
  1: Tier.GOD,
  2: Tier.MASTER,
  3: Tier.JUNIOR,
}
export const graphqlRarityFromModelDataMap: Record<Rarity, GraphqlRarity> = {
  [Rarity.COMMON]: GraphqlRarity.Common,
  [Rarity.SPECIAL]: GraphqlRarity.Special,
  [Rarity.RARE]: GraphqlRarity.Rare,
  [Rarity.EPIC]: GraphqlRarity.Epic,
  [Rarity.LEGENDARY]: GraphqlRarity.Legendary,
}
export const foodTypeToGraphqlMap: Partial<Record<FoodType, GraphqlFoodType>> = {
  [FoodType.FRIES]: GraphqlFoodType.Fries,
  [FoodType.BROCCOLI]: GraphqlFoodType.Broccoli,
}

export const lockedMoleFromGraphqlData = (data: GraphqlLockedMole) => {
  return {
    tokenId: data.tokenId,
    unlockAt: data.unlockAt,
  }
}
